import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MessageBroadcastingService} from '../message-broadcasting.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {UntypedFormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NotificationService} from '../../notification/notification.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';

export interface BroadcastMessagePreviewDialogData {
  totalContacts: number;
  message: string;
  previewFileName: string;
  previewUrl: string;
}

@Component({
    selector: 'app-broadcast-message-preview-dialog',
    templateUrl: './broadcast-message-preview-dialog.component.html',
    styleUrls: ['./broadcast-message-preview-dialog.component.scss'],
    standalone: true,
    imports: [
        MatDialogTitle,
        MatIconButton,
        MatIcon,
        MatDialogClose,
        CdkScrollable,
        MatDialogContent,
        NgIf,
        MatDialogActions,
        MatButton,
    ],
})
export class BroadcastMessagePreviewDialogComponent implements OnInit, OnDestroy {

  constructor(
    public broadcastingService: MessageBroadcastingService,
    public notificationService: NotificationService,
    public dialogRef: MatDialogRef<BroadcastMessagePreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BroadcastMessagePreviewDialogData,
    private fb: UntypedFormBuilder,
  ) {

  }

  ngOnInit() {

  }

  ngOnDestroy() {

  }
}
